export default __webpack_public_path__ + "static/PMG_EGTB_MYRUMAH_CW_AGENCY_ENG-b4bb11ffdb9523f8e9d4cfb2e4ff5b6b.pdf";